const ROUTE_PATHS = Object.freeze({
    DASHBOARD: "/dashboard",
    DASHBOARD_ANALYTICS_PROGRAM: "/dashboard/analytics-program",
    DASHBOARD_SALES_REVENUE: "/dashboard/sales-revenue",
    DASHBOARD_INVENTORY_OPERATIONS: "/dashboard/inventory-operations",
    DASHBOARD_PRODUCT_CATEGORY: "/dashboard/product-category",
    DASHBOARD_COMPLIANCE_DATA_QUALITY: "/dashboard/compliance-data-quality",
    DASHBOARD_CUSTOMER_LOYALTY: "/dashboard/customer-loyalty",
    DASHBOARD_ECOMMERCE: "/dashboard/ecommerce",
    DASHBOARD_FINANCE_MANAGEMENT: "/dashboard/finance-management",
    LOGIN: "/login",
    PRODUCTS: "/products",
    PRODUCTS_CREATE: "/products/create",
    PRODUCTS_BULK_IMPORT: "/products/bulk-import",
    PRINT_LABELS: "/print-labels",
    CUSTOMERS: "/customers",
    CUSTOMERS_IMPORT: "/customer-import",
    CUSTOMER_CREATE: "/customer-create",
    INVENTORY_MANAGER: "/inventory-manager",
    COVA_IMPORT: "/cova-import",
    COVA_RECONCILIATION: "/cova-reconciliation/advanced",
    INVENTORY_ADJUSTMENTS: "/inventory-adjustments",
    INVENTORY_ADJUSTMENTS_QUANTITY: "/inventory-adjustments/quantity",
    ORDERS: "/orders",
    INVOICES: "/invoices",
    PROMOTIONS: "/promotions",
    SETTINGS: "/settings",
    ACCOUNT_AUTOMATION: "/settings/account-automation",
    EMAIL_TEMPLATES: "/settings/email-templates",
    NEWSLETTER_SUBSCRIBERS: "/settings/newsletter-subscribers",
    LOYALTY_MANAGEMENT: "/settings/loyalty-management",
    LOYALTY: "/settings/loyalty",
    LOYALTY_CAMPAIGNS: "/settings/loyalty-campaigns",
    LOYALTY_REWARDS: "/settings/loyalty-rewards",
    LOYALTY_TIERS: "/settings/loyalty-tiers",
    LOYALTY_HEALTH: "/settings/loyalty-health",
    LOYALTY_RECONCILIATION: "/settings/loyalty-reconciliation",
    REPORTS: "/reports",
    MY_PROFILE: "/my-profile",
})

function productDetailPath(id) {
    return `${ROUTE_PATHS.PRODUCTS}/${id}`
}

function productCreatePath(productId = "") {
    return productId ? `${ROUTE_PATHS.PRODUCTS_CREATE}?product_id=${productId}` : ROUTE_PATHS.PRODUCTS_CREATE
}

function printLabelsProductPath(productId) {
    return `${ROUTE_PATHS.PRINT_LABELS}?product_id=${productId}`
}

function customerEditPath(id) {
    return `/customer-edit/${id}`
}

function customerLoyaltyPath(id) {
    return `/customer-loyalty/${id}`
}

function invoiceDetailPath(id) {
    return `${ROUTE_PATHS.INVOICES}/${id}`
}

function purchaseOrderDetailPath(id) {
    return `/purchase-orders/${id}`
}

function stockTransferDetailPath(id) {
    return `/stock-transfers/${id}`
}

function inventoryAdjustmentQuantityPath(id) {
    return `${ROUTE_PATHS.INVENTORY_ADJUSTMENTS_QUANTITY}/${id}`
}

export {
    ROUTE_PATHS,
    productDetailPath,
    productCreatePath,
    printLabelsProductPath,
    customerEditPath,
    customerLoyaltyPath,
    invoiceDetailPath,
    purchaseOrderDetailPath,
    stockTransferDetailPath,
    inventoryAdjustmentQuantityPath,
}
